import { KeyValuePair } from '../../models/key-value-pair';

export class ProviderInstanceModel {
  providerId: string;
  providerInstanceId: string;
  providerTypes: string[];
  name: string;
  annotations: KeyValuePair[];
}
